import {Component, OnInit} from '@angular/core';
import {TimelineComponent, TimelineData} from "../timeline/timeline.component";
import {TimelineDataService} from "../services/timeline-data.service";
import {TimelineSkeletonComponent} from "../shared/timeline-skeleton/timeline-skeleton.component";

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    TimelineComponent,
    TimelineSkeletonComponent,
  ],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent implements OnInit {
  protected loading = true
  protected entities: TimelineData = {
    aboveTimeline: {
      ctmsMilestones : [],
      customMilestones: [],
      congresses: []
    },
    belowTimeline: {
      publications: [],
      activities: [],
      vvpmActivities: []
    }
  }
  constructor(private timelineDataService: TimelineDataService) {
    this.timelineDataService.timelineData.subscribe(data => {
      this.entities = data
      this.loading = false
    })
  }
  ngOnInit(): void {
    // If cached data exists, show it immediately and refresh in background
    if (this.timelineDataService.hasData()) {
      this.entities = this.timelineDataService.getCurrentTimelineData();
      this.loading = false;
      // Silent background refresh — the BehaviorSubject subscription above
      // will update `this.entities` when new data arrives
      this.timelineDataService.fetchData();
    } else {
      // First load — show skeleton until data arrives
      this.loading = true;
      this.timelineDataService.fetchData();
    }
  }
}
